import _ from 'lodash';

const POI = (state = [], action) => {

	switch (action.type) {

		case 'PUT_POI': {

			const { poi } = action.payload;
			const poiType = action.payload.POIType;

			return {
				...state,
				poi: {
					...state.poi,
					[poiType]: {
						results: poi,
					}
				}
			};
		}

		case 'REMOVE_POI': {

			const { POIType } = action.options;

			return {
				...state,
				poi: {
					...state.poi,
					[POIType]: null,
				}
			};
		}

		case 'LOCATION_TIDY_POI': {

			const { POIType, locations } = action.options;
			let new_POI;

			// Filter POI to remove locations that are not still needed
			if (state.poi[POIType] && state.poi[POIType].results) {

				new_POI = _.filter(state.poi[POIType].results, (poi_location) => {

					const match = _.find(locations, (location) => {
						return _.isEqual(poi_location.location, location) ? true : false
					});

					return match ? true : false;
				});

			} else {

				new_POI = state.poi[POIType];
			}

			return {
				...state,
				poi: {
					...state.poi,
					[POIType]: {
						results: new_POI,
					}
				}
			};
		}

		case 'CLEAR_POI': {

			return {
				...state,
				poi: {},
			};
		}

		case 'TOGGLE_POI':

			return {
				...state,
				shown: !state.shown
			};

		default:
			return state;
	}
}
export default POI;



// WEBPACK FOOTER //
// ./src/reducers/POI.js